import { Permission } from './permission.model';
import * as PermissionActions from './permission.actions';

export interface State {
  permissions: Permission[];
}

const initialState: State = {


  permissions: []

};

export function permissionReducer(state = initialState, action: PermissionActions.PermissionActions) {
  switch (action.type) {
    case (PermissionActions.ADD_PERMISSION):

      const updatedPermission = [
        ...action.payload
      ];


      let updatedPermissions = [...state.permissions];
      updatedPermissions = updatedPermission;

      return {
        ...state,
        permissions: updatedPermissions
      };

    default:
      return state;
  }
}
